mutation CheckInAttendee($attendeeId: ID!) {
  checkInAttendee(input: { attendeeId: $attendeeId }) {
    alreadyCheckedIn
    guest {
      id
      status
      checkedInAt
      checkedInByName
    }
  }
}
